/*
 * Header dropdowns: open on hover, and clicking the parent label goes to its link.
 * Only applies on devices with a real mouse (hover + fine pointer).
 * Touch devices and keyboard users keep the default tap/Enter-to-open behaviour.
 */
(() => {
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  const CLOSE_DELAY = 200;

  function setOpen(details, isOpen) {
    const summary = details.querySelector('summary');
    if (isOpen) {
      details.setAttribute('open', '');
    } else {
      details.removeAttribute('open');
    }
    if (summary) summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  function setup(menu) {
    if (menu.dataset.hoverReady) return;
    const details = menu.querySelector('details');
    const summary = details && details.querySelector('summary');
    if (!details || !summary) return;
    menu.dataset.hoverReady = 'true';

    let closeTimer;

    details.addEventListener('mouseenter', () => {
      if (!canHover.matches) return;
      clearTimeout(closeTimer);
      document.querySelectorAll('.header__inline-menu header-menu details[open]').forEach((other) => {
        if (other !== details) setOpen(other, false);
      });
      if (!details.open) setOpen(details, true);
    });

    details.addEventListener('mouseleave', () => {
      if (!canHover.matches) return;
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => setOpen(details, false), CLOSE_DELAY);
    });

    summary.addEventListener('click', (event) => {
      const href = summary.dataset.href;
      // event.detail is 0 for keyboard-triggered clicks, so Enter/Space still toggles the menu.
      if (!href || !canHover.matches || event.detail === 0) return;
      event.preventDefault();
      window.location.href = href;
    });
  }

  function init() {
    document.querySelectorAll('.header__inline-menu header-menu').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
